<template>
  <validation-provider
    :rules="validationRules"
    v-slot="{ errors }"
    mode="passive"
    tag="div"
    class="relative"
  >
    <div class="flex justify-between items-center mb-2">
      <label :for="inputName" class="block text-grey-700 text-sm">{{
        inputName
      }}</label>
      <slot />
    </div>
    <input
      v-model="value"
      :type="inputType"
      :id="inputName"
      class="
        text-base text-black-900
        rounded
        border border-grey-500
        px-2
        py-2
        w-full
      "
      :class="{ 'border-red-600': isSubmitted && errors && errors.length }"
    />
    <p
      v-if="isSubmitted && errors && errors.length"
      class="absolute left-0 top-full mt-1 text-xs text-red-600"
    >
      {{ errors[0] }}
    </p>
  </validation-provider>
</template>

<script>
import { ValidationProvider } from "vee-validate";

export default {
  name: "UtilsInput",
  components: {
    ValidationProvider,
  },
  props: {
    validationRules: {
      type: String,
      required: true,
    },
    inputName: {
      type: String,
      required: true,
    },
    inputType: {
      type: String,
      required: true,
    },
    isSubmitted: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      value: null,
    };
  },
};
</script>
